export default {
  inject: ['table'],
  props: {
    id: String,
    pureId: String,
    invisible: Boolean,
  },
  data() {
    return {
      html: '',
    };
  },
  computed: {
    selectorChecked() {
      return this.table.selectedRowKeys.length === this.table.data.length && this.table.data.length !== 0;
    },
    className() {
      return [
        'ten-table__table-cell',
        {
          'ten-table__table-cell--invisible': this.invisible,
        },
      ];
    },
  },
  watch: {
    invisible(v, ov) {
      if (!v && ov && this.$el) {
        this.$el.innerHTML = '';
      }
    },
  },
  created() {
    this.table.addCell(this);
  },
  updated() {
    if (!this.invisible) {
      this.table.updateInvisibleCell(this.pureId, this);
    }
  },
  mounted() {
    if (!this.invisible) {
      setTimeout(() => {
        this.table.updateInvisibleCell(this.pureId, this);
      });
    }
  },
  destroyed() {
    this.table.removeCell(this);
  },
  methods: {
    syncFromVisibleCell(visibleCell) {
      if (this.invisible && this.$el.innerHTML !== visibleCell.$el.innerHTML) {
        this.$el.innerHTML = visibleCell.$el.innerHTML;
      }
    },
  },
};
